// @flow
import React from "react";

import styles from "./FAQs.module.scss";
import CollapsibleContainer from "../CollapsibleContainer";
import useToggle from "../../hooks/useToggle";
import Typography from "../Typography";
import FaqIcon from "../qicons/FaqIcon";
import MinusIcon from "../qicons/MinusIcon";
import PlusIcon from "../qicons/PlusIcon";
import BasicButton from "../BasicButton";

type FAQ = {
  question: string,
  answer: string
};

type Props = {
  faqs: Array<FAQ>
};

type FAQProps = FAQ;

const FAQItem = ({ question, answer }: FAQProps) => {
  const [open, toggleOpen] = useToggle(false);

  return (
    <div
      className={styles.faq}
      data-cy="faq-item"
      itemScope
      itemProp="mainEntity"
      itemType="https://schema.org/Question"
    >
      <div className={styles.header}>
        <span className={styles.questionIcon}>
          <FaqIcon size="1x" />
        </span>

        <BasicButton
          className={styles.clickTarget}
          onClick={() => toggleOpen()}
        >
          <Typography bold>
            <span className={styles.headerText} itemProp="name">
              {question}
            </span>
          </Typography>
          <span className={styles.expandIcon}>
            {open ? <MinusIcon size="1x" /> : <PlusIcon size="1x" />}
          </span>
        </BasicButton>
      </div>
      <div
        className={styles.contentContainer}
        itemScope
        itemProp="acceptedAnswer"
        itemType="https://schema.org/Answer"
      >
        <CollapsibleContainer isOpened={open}>
          <div
            className={styles.content}
            itemProp="text"
            data-cy="faq-item-content"
          >
            {answer}
          </div>
        </CollapsibleContainer>
      </div>
    </div>
  );
};

const FAQs = ({ faqs }: Props) => {
  return (
    <div
      data-cy="faq-container"
      className={styles.base}
      itemScope
      itemType="https://schema.org/FAQPage"
    >
      {faqs.map(({ question, answer }) => (
        <FAQItem key={question} question={question} answer={answer} />
      ))}
    </div>
  );
};

export default FAQs;
